<template>
  <div class="cell">
    <div id="heading" class="cellColumn">{{notification.headings.en}}</div>
    <div id="content" class="cellColumn">{{notification.contents.en}}</div>
    <div id="cellData" class="cellColumn" v-if="notification.url">{{notification.url}}</div>
    <div id="cellData" class="cellColumn" v-else>-</div>
    <div id="cellData" class="cellColumn">
      <img
        style="width:50px; height 50px"
        v-if="notification.ios_attachments"
        v-bind:src="notification.ios_attachments.image"
      />
      <div style="width:30px; height 30px" id="cellData" class="cellColumn" v-else>-</div>
    </div>
    <div id="cellData" class="cellColumn">{{formatDate(notification.send_after)}}</div>
    <div id="cellButtonContainer" class="cellColumn">
      <button
        class="button"
        v-on:click="editButtonAction(notification)"
        v-if="!isFutureDate(notification)"
      >
        <img class="buttonImage" src="../assets/EditIcon@3x.png" />
      </button>
      <button
        class="button"
        v-on:click="deleteButtonAction(notification)"
        v-if="!isFutureDate(notification)"
      >
        <img class="buttonImage" src="../assets/DeleteIcon@3x.png" />
      </button>
      <button
        class="button"
        v-on:click="showButtonAction(notification)"
        v-if="isFutureDate(notification)"
      >
        <img class="buttonImage" src="../assets/ViewIcon@3x.png" />
      </button>
    </div>
    <modal name="notification-form-modal">
      <div>
        <notification-form />
      </div>
    </modal>
  </div>
</template>

<script>
import NotificationForm from "./NotificationForm.vue";
import Swal from "sweetalert2/dist/sweetalert2.js";
export default {
  name: "NotificationCell",
  components: {
    NotificationForm,
  },
  props: {
    notification: Object,
  },
  data() {
    return {
      app_id: "8fb80b4e-299a-404a-aeab-1ba0a0db9430",
    };
  },
  methods: {
    formatDate(unixDate) {
      if (unixDate) {
        let date = new Date(unixDate * 1000);
        var dateString = new Date(
          date.getTime() - date.getTimezoneOffset() * 60000
        )
          .toISOString()
          .split("T")[0];
        return dateString;
      }
    },
    isFutureDate(notification) {
      let currentUnixDate = Math.round(new Date().getTime() / 1000);
      return notification.send_after < currentUnixDate;
    },

    showForm(notification) {
      this.$modal.show(
        NotificationForm,
        {
          startData: notification,
          isEditable: true,
          view: true,
        },
        {
          width: "60%",
          clickToClose: false,
        },
        {
          "before-close": this.beforeModalClose,
        }
      );
    },
    deleteButtonAction(notification) {
      console.log(notification);
      Swal.fire({
        title: "Delete notification",
        text: "Are you sure you want to delete this notification?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes. Delete",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.value) {
          this.deleteNotification(notification).then(() => {
            Swal.fire(
              "Deleted!",
              "Notification Successfully Deleted.",
              "success"
            );
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          //Swal.fire("Cancelled", "Action canceled", "error");
        }
      });
      // this.$confirm(
      //   "Are you sure you want to delete this notification?",
      //   "Delete notification"
      // ).then(() => {
      //   this.deleteNotification(notification).then(() => {
      //     this.$alert("Notification Successfully Deleted");
      //   });
      // });
    },
    showButtonAction(notification) {
      console.log(notification)

      this.$modal.show( NotificationForm,
      {
        startData: notification, isEditable: false, view: true
      },
      {
        width: '60%',
        clickToClose: false
      },
      {
        'before-close': this.beforeModalClose
      })
      // this.$modal.show(
      //   NotificationForm,
      //   { startData: notification, isEditable: false, view: true },
      //   {'clickToClose': false},
      //   { width: "60%"},{
      //   'closed': this.beforeModalClose
      //   }
      // );
    },
    beforeModalClose(event) {
      console.log("CLOSE", event);
      this.$parent.getNotifications();
    },
    async deleteNotification(notification) {
      var headers = {
        Authorization: "Basic YmI4OGIwODUtMTM4NC00YTY1LTkyMTktNjNhZDMzZmNhZTIx",
      };
      const request = new Request(
        `https://onesignal.com/api/v1/notifications/` +
          notification.id +
          `?app_id=${this.app_id}`,
        {
          port: 443,
          method: "DELETE",
          headers: headers,
        }
      );
      const res = await fetch(request);
      const result = await res.json();
      this.$parent.getNotifications();
      console.log(result);
    },
    async editButtonAction(notification) {
      // this.deleteNotification(notification);
      notification.edit = true;
             this.$modal.show( NotificationForm,
      {
        startData: notification, isEditable: true
      },
      {
        width: '60%',
        clickToClose: false
      },
      {
        'before-close': this.beforeModalClose

      })
    },
  },
};
</script>

<style scoped>
.cell {
  height: 60px;
  width: 100%;
  display: flex;
  background-color: white;
  justify-content: center;
  align-items: center;
  border: solid 1px #f5f6f8;
  overflow: "auto";
}
.cellColumn {
  display: flex;
  justify-content: left;
  align-items: center;
  text-align: left;
  scrollbar-width: none;
  height: 100%;
  margin: 0 10px 0 10px;
}
.buttonImage {
  width: 100%;
}
#id {
  width: 2%;
  text-align: center;
}
#heading {
  margin-left: 0;
  width: 12%;
  text-align: center;
}
#content {
  width: 30%;
}
#cellData {
  width: 15%;
  text-align: left;
}
#cellButtonContainer {
  width: 5%;
}
.button {
  font-size: 10px;
  width: 50%;
  border-radius: 4px;
  border: none;
  transition-duration: 0.4s;
  background-color: white;
}
.button:hover {
  background-color: rgba(16, 156, 241, 0.05);
}
.button:disabled {
  color: rgba(16, 156, 241, 0.05);
}
body {
  overflow: hidden;
}
</style>